import React from "react";

type TooltipSidebarProps = {
  text: string;
  position?: string; // extra Tailwind classes for positioning
  className?: string; 
};

export default function TooltipSidebar({ text, position  ,className}: TooltipSidebarProps) {
  return (
    <div
      className={`absolute ${position || "-top-7 left-1/2 -translate-x-1/2"} 
      px-1 py-1 text-[10px] text-white font-bold bg-gradient-to-r from-[#222222] via-[#06baba] to-[#222222] 
  bg-[length:200%_200%] animate-[gradient-x_4s_ease_infinite]  rounded-md opacity-0 scale-90 
      group-hover:opacity-100 group-hover:scale-100 transition-all duration-[400ms] normal-case pointer-events-none 
      whitespace-nowrap z-[99999]  ${className}`}
    >
      {text}
    
    </div>
  );
}
